/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

export class TextViewClasses {
    static DEFAULT: string = 'default';

    static TITLE: string = 'title';

    static DESCRIPTION: string = 'description';

    static PROGRAM_DESCRIPTION: string = 'program-description';

    static SUBTITLE: string = 'subtitle';

    static MESSAGE_CODE: string = 'message-code';

    static SELECT_BUTTON_TEXT: string = 'select-button-text';

    static FADED_DESCRIPTION: string = 'faded-description';
}
